class ProductModellist extends HTMLElement {
  connectedCallback() {
    // This is inside a setTimeout to ensure the machine-controller
    // script is loaded before we try to access it, as this script
    // is part of a section while the machine-controller is in the footer of the page.
    setTimeout(() => {
      const controller = window.getMachineController?.();
      if (!controller) return;

      const currentModel = controller.getCurrentState().model;
      this.setActiveCompatibleModels(currentModel);
    }, 0);

    this.models = Array.from(this.querySelectorAll('li[data-model-name]'));
    this.unsubscribeMachineChange = subscribe('machine:change', (machineData) => {
      this.setActiveCompatibleModels(machineData.model);
    });
  }

  disconnectedCallback() {
    this.unsubscribeMachineChange();
  }

  setActiveCompatibleModels(selectedModel) {
    const modelToCheckFor = selectedModel || '';

    this.models.forEach((modelElement) => {
      const modelName = modelElement.dataset.modelName;

      if (modelName === modelToCheckFor) {
        modelElement.dataset.active = 'true';
      } else {
        modelElement.dataset.active = 'false';
      }
    });
  }
}

customElements.define('product-model-list', ProductModellist);
